/** Light frosted sidebar + translucent active states (works with gray-50 app shell). */

export const sidebarShell = {
  desktop:
    'flex flex-col flex-grow overflow-y-auto relative bg-white/85 backdrop-blur-xl border-r border-slate-200/70 shadow-[4px_0_24px_-12px_rgba(15,23,42,0.06)]',
  desktopAmbient: 'pointer-events-none absolute inset-0 bg-gradient-to-b from-slate-50/80 via-white/40 to-slate-50/30',
  mobile:
    'relative flex flex-1 flex-col max-w-xs w-full bg-white/95 backdrop-blur-xl border-r border-slate-200 shadow-xl mobile-safe-area',
  mobileOverlay: 'fixed inset-0 bg-slate-900/25 backdrop-blur-[2px]',
} as const;

export const sidebarSectionLabel =
  'px-3 pt-5 pb-1.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400 select-none';

export const sidebarNavItem = {
  base: 'group relative flex items-center rounded-xl font-medium outline-none transition-all duration-200 ease-out',
  spacingExpanded: 'gap-3 px-3 py-2.5 text-sm',
  spacingCollapsed: 'justify-center px-2 py-2.5',
  spacingMobile: 'gap-3 px-3 py-3.5 text-sm min-h-[3rem] touch-manipulation',
  inactive:
    'text-slate-600 border border-transparent hover:bg-slate-900/[0.04] hover:text-slate-900',
  active:
    'text-blue-800 bg-blue-500/[0.09] backdrop-blur-md border border-blue-500/20 shadow-[inset_0_1px_0_rgba(255,255,255,0.65),0_0_0_1px_rgba(59,130,246,0.04),0_4px_14px_-4px_rgba(59,130,246,0.18)]',
  activeLabel: 'font-semibold text-blue-900',
  focus:
    'focus-visible:ring-2 focus-visible:ring-blue-500/30 focus-visible:ring-offset-2 focus-visible:ring-offset-white',
} as const;

export const sidebarNavIcon = {
  base: 'shrink-0 transition-[color,opacity] duration-200 ease-out',
  sizeExpanded: 'h-[18px] w-[18px]',
  sizeMobile: 'h-5 w-5',
  inactive: 'text-slate-500 group-hover:text-slate-700',
  active: 'text-blue-600',
} as const;

export const sidebarCollapsedTooltip =
  'pointer-events-none absolute left-[calc(100%+0.5rem)] top-1/2 z-50 -translate-y-1/2 whitespace-nowrap rounded-lg border border-slate-200 bg-white/95 px-2.5 py-1.5 text-xs font-medium text-slate-800 opacity-0 shadow-lg backdrop-blur-md transition-opacity duration-200 group-hover:opacity-100 group-focus-within:opacity-100';
